import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { DataSource } from '../../lib/data-source/data-source';
import { Column } from '../../lib/data-set/column';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ng2-smart-table-filter',
    styleUrls: ['./filter.component.scss'],
    template: `
      @if (column.isFilterable) {
        <div class="ng2-smart-filter">
          @switch (column.getFilterType()) {
            @case ('list') {
              <select-filter [query]="query"
                             [ngClass]="inputClass"
                             [column]="column"
                             (filter)="onFilter($event)">
              </select-filter>
            }
            @case ('checkbox') {
              <checkbox-filter [query]="query"
                               [ngClass]="inputClass"
                               [column]="column"
                               (filter)="onFilter($event)">
              </checkbox-filter>
            }
            @case ('completer') {
              <completer-filter [query]="query"
                                [ngClass]="inputClass"
                                [column]="column"
                                (filter)="onFilter($event)">
              </completer-filter>
            }
            @default {
              <input-filter [query]="query"
                            [ngClass]="inputClass"
                            [column]="column"
                            (filter)="onFilter($event)">
              </input-filter>
            }
          }
        </div>
      }
    `,
    standalone: false
})
export class FilterComponent implements OnChanges {

  @Input() public column: Column;
  @Input() public source: DataSource;
  @Input() public inputClass: string = '';

  @Output() public filter = new EventEmitter<any>();

  public query: string = '';

  protected dataChangedSub: Subscription;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.source) {
      if (!changes.source.firstChange) {
        this.dataChangedSub.unsubscribe();
      }
      this.dataChangedSub = this.source.onChanged().subscribe((dataChanges) => {
        const filterConf = this.source.getFilter();
        if (filterConf && filterConf.filters && filterConf.filters.length === 0) {
          this.query = '';

          // add a check for existing filters an set the query if one exists for this column
          // this covers instances where the filter is set by user code
          // while maintaining existing functionality
        } else if (filterConf && filterConf.filters && filterConf.filters.length > 0) {
          filterConf.filters.forEach((k: any, v: any) => {
            if (k.field === this.column.id) {
              this.query = k.search;
            }
          });
        }
      });
    }
  }

  public onFilter(query: string) {
    this.source.addFilter({
      field: this.column.id,
      search: query,
      filter: this.column.getFilterFunction(),
    });
  }
}
